import { css } from '@bts-web/utils-style-engine';
import { getAppConfig } from '@bts-web/core-app-config';
import { SkeletonElement } from '../../../common/components';
import { AppLogoWithIslamicProp } from '../Reusable/AppLogo/AppLogoWithIslamicProp.use-client';
import { DEFAULT_MOBILE_LOGO_SIZE } from '../../constants';

const MobileHeaderSkeleton = () => {
  const { appLogoSize } = getAppConfig();

  return (
    <div
      className={css({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingX: 'medium',
        minHeight: '64px',
      })}
      data-testid="mobile-header-skeleton"
    >
      <div
        className={css({
          display: 'flex',
          alignItems: 'center',
          gap: 'medium',
        })}
      >
        <AppLogoWithIslamicProp
          size={appLogoSize || DEFAULT_MOBILE_LOGO_SIZE}
          textLogoSize={160}
        />
      </div>

      <div className={css({ display: 'flex', gap: 'small' })}>
        <SkeletonElement width="20px" height="20px" />
        <SkeletonElement width="20px" height="20px" />
      </div>
    </div>
  );
};

export { MobileHeaderSkeleton };
